/* global axios */
import ApiClient from './ApiClient';

class AiDashboardAPI extends ApiClient {
  constructor() {
    super('ai_dashboard', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new AiDashboardAPI();
